/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Billing_Bills_ComingInputs */



/**
* | output |
* | --- |
* | "{count} more customers still to close this month" |
*
* @param {Partner_Billing_Bills_ComingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_bills_coming = /** @type {((inputs: Partner_Billing_Bills_ComingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Bills_ComingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} weitere Kunden schließen diesen Monat noch ab`)
	return /** @type {LocalizedString} */ (`${i?.count} more customers still to close this month`)
});